import { HOST } from "common-import/constants";
import { observable, autorun } from "mobx";
import { Request, MobXHelper } from "common-import/helpers";
const { makePersit } = MobXHelper;
import api from "./User.API";

const GlobalEvent = require('js-events-listener');

const PERSIST_STORE_ITEM = {
  USER_DATA: "USER_STORE_USER_DATA"
}

class UserStore {
  constructor() {
    this.loadInitialData();
  }
  @observable userData = {};

  @observable listUser = [];

  getToken = () => this.userData.keyJWT

  loadInitialData = async () => {
    let userData = await makePersit.persist(PERSIST_STORE_ITEM.USER_DATA, "object");
    if (userData != undefined) this.userData = userData;

    let res = await this.getUserInfo();
    if (res.data != undefined) this.userData = {...this.userData, ...res.data};
    else if (res.error === 'NOT_AUTHEN' && this.getToken() !== undefined) {
      alert('Your session has expried. Please login again!');
      this.logout();
    }
    else if (res.error === 'NOT_AUTHEN') {
      alert('You have to login first!');
      this.logout();
    }
    GlobalEvent.emit("USER_STORE_READY", this.userData);
  }

  onReady = callback => new Promise((resolve, reject) => {
    const run = () => {
      typeof callback === 'function' && callback(this.userData);
      resolve(this.userData);
    }
    if (this.isAuth()) run();
    else GlobalEvent.on("USER_STORE_READY", run);
  });

  isAuth = () => {
    if (this.userData == undefined) return false;
    return typeof this.userData.keyJWT === "string";
  } 

  register = async (obj) => {
    let res = await api.register(obj);
    const json = await res.json();
    return json;
  }

  loginNormal = async ({ email, password }) => {
    let res = await api.loginNormal({ email, password, type: "normal" });
    let json = await res.json();
    if(!!json.error) return json;
    this.userData = json.data;
    return json;
  }

  getUserInfo = async () => {
    let res = await api.me();
    let json = await res.json();
    return json;
  }

  logout = async () => {
    api.logout();
    this.userData = {};
    localStorage.clear();
    // location.reload();
    document.location = "/#/login";
    return;
  }

  adminList = async data => {
    let res = await api.adminList(data);
    let json = await res.json();
    if(!!json.error) return json;
    this.listUser = json.data;
    return json;
  }

  getUserDetailById = async id => {
    let res = await api.detail(id);
    let json = await res.json();
    if(!!json.error) return json;
    this.listUser = json.data;
    return json;
  }
}

const userStore = new UserStore();

autorun(() => {
  makePersit.make(userStore.userData, PERSIST_STORE_ITEM.USER_DATA)
});

export default userStore;


// WEBPACK FOOTER //
// ./src/services/user/User.Store.js